import {AfterViewInit, Component, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {StateService} from "../../services/state.service";
import {UserRole} from "../../models/user";
import {ProtestInfoService} from "../../services/protest-info.service";
import {NgForm, Validators} from "@angular/forms";
import {UtilService} from "../../services/util.service";
import {ProtestInfo} from "../../models/protest";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort, Sort} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";

@Component({
    selector: 'app-join-request',
    templateUrl: './join-request.component.html',
    styleUrl: './join-request.component.scss',
    standalone: false
})
export class JoinRequestComponent implements OnInit, AfterViewInit {

  @ViewChild('searchForm') searchForm!: NgForm;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  typeOfRequest = '';
  headerText = '';
  searchMessage = '';
  requestMessage = '';
  searchNote = '';
  userRole = '';
  bNum = '';
  bNumber = '';
  protestInfo: ProtestInfo[] = [];
  protestInfoRow!: ProtestInfo;
  displayedColumns: string[] = ['b_No', 'company_Name', 'submission_Date', 'agency_Name', 'solicitation_No', 'due_Date', 'request'];
  dataSource: MatTableDataSource<ProtestInfo> = new MatTableDataSource();
  pageLocalStorageKey = "joint-request_page_size";

  loading = true;
  searching = false;

  isSearchVisible = true;
  isSearchResultVisible = false;
  isIntervenorFormVisible = false;

  scrollClass = "";

  constructor(private readonly util: UtilService,
              public readonly stateService: StateService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute,
              private readonly protestInfoService: ProtestInfoService) {
  }

  ngOnInit() {
    this.typeOfRequest = this.activatedRoute.snapshot.url[0].path;
    this.getAccessRequest();
  }

  ngAfterViewInit() {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.util.sortingDataAccessor;
      console.debug(this.dataSource.paginator);
      console.debug(this.dataSource.sort);
    }
  }

  getAccessRequest() {
    this.protestInfoService.requestToCaseAccess().subscribe(access => {
      console.debug(access);
      this.userRole = access.user_Role;

      if (this.userRole === 'AGENCY ATTORNEY') {
        this.headerText = 'Join a Case';
        this.searchMessage = '<strong>Please enter the B-number in the box above. If you do not know the B-number for the case you would like to join, please select the search button and a complete list of your agency\'s open cases will be retrieved.</strong>';
        this.requestMessage = 'Do you want to enter an appearance in this case?';
        this.scrollClass = "join-scroll-height";
      } else if (this.userRole === 'INTERVENOR') {
        this.headerText = 'Request to Intervene';
        this.searchMessage = 'In order to intervene in a bid protest, you must know the B-number assigned to the case by GAO. To find the B-number assigned to a case, please check GAO\'s docket, where you can search for cases by agency, solicitation number, or protester. GAO\'s docket is accessible <a href="http://gao.gov/legal/bid-protests/search" target="blank">here</a>.';
        this.searchNote = '<strong>Note:  Intervenor means an awardee if the award has been made or, if no award has been made, all bidders or offerors who appear to have a substantial prospect of receiving an award if the protest is denied. To intervene in a case, you will be required to upload a document explaining how you satisfy the above requirements.</strong>';
        this.requestMessage = 'Do you want to request to intervene in this case?';
        this.scrollClass = "int-scroll-height";

        if (this.searchForm) {
          this.searchForm.controls['bNumField'].addValidators([Validators.required, Validators.minLength(6)]);
          this.searchForm.controls['bNumField'].updateValueAndValidity();
        }

      } else {
        this.router.navigate([this.util.getDashboardURL()]);
      }

      this.loading = false;
    });
  };

  onSearch() {
    console.debug(this.bNum);
    this.bNumber = 'B-' + this.bNum;

    this.isIntervenorFormVisible = false;

    if (this.typeOfRequest === 'intervene') {
      this.intervenorProtestSearch();
    } else {
      this.agencyRepProtestSearch();
    }
  }

  onBNumChange(event: any) {
    this.searchForm.controls['bNumField'].updateValueAndValidity();
  }

  intervenorProtestSearch() {
    this.searching = true;

    this.protestInfoService.getListOfProtestsForIntervenor(this.bNumber).subscribe(listOfProtests => {
      if (listOfProtests) {
        this.protestInfo = listOfProtests.protestInfoList;
        this.processProtestList();
      }

      this.searching = false;
    });
  }

  agencyRepProtestSearch() {
    this.searching = true;

    this.protestInfoService.getListOfProtestsForAgencyRep(this.bNumber).subscribe(listOfProtests => {
      if (listOfProtests) {
        this.protestInfo = listOfProtests.protestInfoList;
        this.processProtestList();
      }

      this.searching = false;
    });
  }

  processProtestList() {
    console.debug(this.protestInfo);
    this.searching = false;

    if (this.protestInfo.length === 0) {
      this.displayNotFoundDialog();
    } else {
      this.dataSource.data = [...this.protestInfo];
      this.isSearchResultVisible = true;
    }
  }

  displayNotFoundDialog() {
    this.util.displayDialogMessage('Not Found',
      'We cannot find the case that you are looking for. This might be because you already have access to the case, you already have a pending request to access the case, or the case is closed.  Please check the B# and try again.').subscribe();
  }

  onRequestToIntervene(row: ProtestInfo) {
    // console.debug(row);
    this.protestInfoRow = row;
    this.isSearchVisible = false;
    this.isSearchResultVisible = false;
    this.isIntervenorFormVisible = true;
  }

  onIntervenorSubmit() {
    this.isIntervenorFormVisible = false;
    this.router.navigate([this.util.getDashboardURL()]);
  }

  onIntervenorCancel() {
    this.isIntervenorFormVisible = false;
    this.isSearchVisible = true;
    this.isSearchResultVisible = true;
  }

  onSortChange(sortState: Sort) {
    this.util.announceSortChange(sortState);
  }

  eventFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value ?? '';
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  protected readonly UserRole = UserRole;
}
